module.exports = ".modal-pdf-container {\n    width: 800px;\n}\n\n.pdf-html-container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    margin: 0 auto;\n    max-width: 700px;\n    width: 100%;\n    height: 400px;\n    overflow-y: auto;\n    margin-right: 72px;\n    text-align: justify;\n}\n\n.container-btn-modal {\n    padding-right: 42px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/modal-pdf/modal-pdf.component.css
// module id = ./src/app/shared/components/modal-pdf/modal-pdf.component.css
// module chunks = main